import { RouterProvider } from "react-router-dom";
import { MyRoutes } from "routers";

function App() {
  return (
    <div className="bg-white text-base dark:bg-neutral-900 text-neutral-900 dark:text-neutral-200">
      <RouterProvider router={MyRoutes} />
    </div>
  );
}

export default App;
